import { Component } from 'react';
import PropTypes from 'prop-types';

import config from 'config/config';
import { findDOMNode } from 'react-dom';
import clipboardSupport from 'app/scripts/services/clipboard';
import noop from 'utils/noop';
import { autobind } from 'core-decorators';
import ZeroClipboard from 'zeroclipboard';

ZeroClipboard.config({ swfPath: config.zeroclipboard });

class ClickToCopy extends Component {
  static displayName = 'ClickToCopy';
  static propTypes = {
    content: PropTypes.string.isRequired,
    onCopy: PropTypes.func,
    text: PropTypes.string,
    className: PropTypes.string
  };
  static defaultProps = {
    onCopy: noop,
    text: 'Copy'
  };

  componentDidMount() {
    // if (clipboardSupport.clipboardStrategy() === 'flash') {
    var domNode = findDOMNode(this);
    this.zeroClipboard = new ZeroClipboard(domNode);
    var clipboard = this.zeroClipboard;

    clipboard.on('ready', () => {
      clipboard.on('copy', event => {
        var { client, id } = event;
        if ((client && client === clipboard) || (id && id === clipboard.id)) {
          clipboard.setText(this.props.content);
          this.props.onCopy(this);
        }
      });
    });
    // }
  }

  componentWillUnmount() {
    //if (clipboardSupport.clipboardStrategy() === 'flash') {
    this.zeroClipboard.destroy();
    //}
  }

  @autobind
  nativeCopy() {
    var input = document.createElement('input');
    input.type = 'text';
    input.value = this.props.content;

    document.body.appendChild(input);
    input.select();

    var copySuccess = false;
    try {
      copySuccess = document.execCommand('copy');
    } catch (e) {
      copySuccess = false;
    }

    document.body.removeChild(input);

    if (copySuccess) {
      this.props.onCopy(this);
    }
  }

  render() {
    let { text } = this.props;
    var onClick = this.nativeCopy;
    let className = 'copy';
    if (this.props.className) {
      className += ` ${this.props.className}`;
    }
    return (
      <div onClick={onClick} className={className}>
        {text}
      </div>
    );
  }
}

export default ClickToCopy;
